import { Formik } from 'formik';
import { useState, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBackIosNew } from 'react-icons/md';
import { countrySchema } from '../../../../../constants';
import { DAV_APIS } from '../../../../../adapters';
import { Alert, SEO } from '../../../../commons';
import CountryForm from '../CountryForm';
import { getCountryFlag } from '../../../../../utils';
import { Button } from '../../../../ui/Button';

const NewCountryPage: FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const newCountrySubmitHandler = async (values: any) => {
    setLoading(true);
    try {
      const countryFlag = await getCountryFlag(values.name);
      const data = {
        name: values.name,
        title: values.title,
        description: values.description,
        countrySummary: values.countrySummary,
        countryImage: values.imageFile,
        flag: countryFlag,
      };
      const res = await DAV_APIS.country.createCountry(data);
      setLoading(false);
      if (res.status === 201) {
        Alert({ variant: 'success', message: 'Country created successfully' });
        navigate('/dashboard/countries');
      }
    } catch (error) {
      setLoading(false);
      Alert({ variant: 'error', message: 'Failed to create country, Please try again' });
    }
  };

  return (
    <div className='w-full space-y-6 pt-4 pb-10'>
      <div className='flex items-center'>
        <button
          onClick={() => navigate('/dashboard/countries')}
          type='button'
          className='flex items-center gap-2 text-gray-500 hover:text-primary-600 transition-colors font-semibold'
        >
          <MdArrowBackIosNew className='w-4 h-4' />
          <span>Back to Destinations</span>
        </button>
      </div>

      <Formik
        enableReinitialize
        initialValues={{
          name: '',
          title: '',
          description: '',
          imageCover: '',
          imageFile: '',
          countrySummary: '',
        }}
        validationSchema={countrySchema}
        onSubmit={async (values, { resetForm }) => {
          await newCountrySubmitHandler(values);
          resetForm();
        }}
      >
        {({ handleSubmit, values, setFieldValue, dirty, isValid }) => (
          <div className='space-y-10'>
            <div className='bg-white dark:bg-gray-800 rounded-2xl p-8 border border-gray-100 dark:border-gray-700 shadow-sm'>
              <h1 className='text-3xl font-extrabold text-gray-900 dark:text-white mb-8 text-center tracking-tight'>
                Add New Destination
              </h1>

              <form onSubmit={handleSubmit} className='w-full'>
                <CountryForm values={values} setFieldValue={setFieldValue} />
                <div className='flex justify-center mt-10 border-t border-gray-100 dark:border-gray-700 pt-8'>
                  <Button
                    type='submit'
                    variant='primary'
                    loading={loading}
                    disabled={!dirty || !isValid}
                    className='w-full sm:w-64'
                  >
                    Create Country
                  </Button>
                </div>
              </form>
            </div>
            <SEO
              pageType='country'
              initialData={{
                title: values.name,
                description: values.description,
                image: values.imageCover,
              }}
            />
          </div>
        )}
      </Formik>
    </div>
  );
};

export default NewCountryPage;
